// Appwrite SDK throws AppwriteException (Error subclass with a `code`); anything else caught
// here is typically a rethrown plain Error, so both are covered by the same instanceof check.
export function getErrorMessage(e: unknown): string {
    return e instanceof Error ? e.message : String(e);
}
